import { DropdownModel } from "../../shared/models/dropdown.model"

export class CompanyModel {
  companyName: string;
  companyEmail: string;
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  confirmPassword: string;
  newCode: string;
  confirmCode: string;
  contact: string;
  questionCateogaryList: DropdownModel[];
  mstComplianceList: DropdownModel[];
  limitationOfPolicy: number;
}


export class CompanyListModel {
  companyId: number;
  companyName: string;
  noOfLocation: string;
  noOfEmployee: string;
  contactNo: string;
  extContactNo: string;
  status: string;
  isActive: boolean;
  description: string;
  isEditMode: boolean = false;
  address: string = "";
  companyEmail: string = "";
  serviceNameString: string;
  isApproved: boolean;
  approvedStatus: string = "";
  isDeleted: boolean;
}

export class CompanyUserModel {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  extPhoneNumber: string;
  role: string;
  address: string;
  departmentId: number;
  departmentName: string;
  clientUserTitleId: number;
  clientUserTitleName: string;
  departmentList: DropdownModel[];
  companyId: number;
  companyName: string;
  userName: string;
  entityString: string;
  isEditMode: boolean = false;
  isActive: boolean;
  status: string;
  fax: string;
  title: string;
  emailConfirmed:boolean;
  twoFactorEnabled:boolean;
}


export class CompanyCreateModel {
  companyName: string;
  firstName: string;
  lastName: string;
  email: string;
  extContact: string;
  contact: string;
  companyAddress: string;
  primaryContact: CompanyContactModel;
  secondaryContact: CompanyContactModel;
  questionCateogaryList: DropdownModel[];
  mstServiceList: DropdownModel[];
  mstComplianceList: DropdownModel[];
  subscriptionId: DropdownModel;
  subscriptionList: DropdownModel[];
  companyEmail: string;
  noOfEmployee: DropdownModel;
  noOfLocation: DropdownModel;
  year: number;
  startDate: string;
  noOfDefaultMonths: number;
  duration: number;
  dmyDays: number;
  employeeNoList : DropdownModel[];
  companyAddressModel: AddressModel;
  limitationOfPolicy: any;
  locationNoList: DropdownModel[];
  userId : string;
  id: string;
  //companyStreet: string;
  //companyCity: string;
  //companyState: string;
  //companyCountry: string;
  //companyZipCode: string;
}

export class CompanyCountPolicyModel {
  questionCateogaryList: DropdownModel[];
  mstComplianceList: DropdownModel[];
}


export class CompanyEditModel {
  companyId: number;
  companyName: string;
  companyAddress: string;
  extContact: string;
  contact: string;
  primaryContact: CompanyContactModel;
  secondaryContact: CompanyContactModel;
  questionCateogaryList: DropdownModel[];
  mstServiceList: DropdownModel[];
  mstComplianceList: DropdownModel[];
  subscriptionId: DropdownModel;
  companyEmail: string;
  noOfEmployee: DropdownModel;
  noOfLocation: DropdownModel;
  companyAddressModel: AddressModel;
  limitationOfPolicy: number;
  region: string;
  district: string;
}


export class CompanyContactModel {
  firstName: string;
  lastName: string;
  email: string;
  address: string;
  faxNo: string;
  title: string;
  extWorkPhoneNo: string;
  extHomePhoneNo: string;
  workPhoneNo: string;
  cellPhoneNo: string;
  homePhoneNo: string;
  ExtCellPhoneNo : string;
  addressModel = AddressModel;
}

export class AddressModel {
  street: string;
  city: string;
  state: string;
  country: string;
  zipCode: string;
}

export class CompanyPermissionModel {
  companyId: number;
  permissionsList: DropdownModel[];
}
export class BsUserList {
  userId: string;
  userName: string;
}



export class SubscriptionServiceList {
  subscriptionId: number;
  subscriptionName: string;
  serviceList: ServiceList[];
}

export class ServiceList {
  serviceId: number;
  serviceName: string;
}


export class CompanyEditCountryStateModel{
  selectedCountryName: string;
  selectedStateName: string;
  selectedPrimaryCountryName: string;
  selectedPrimaryStateName: string;
  selectedSecondaryCountryName: string;
  selectedSecondaryStateName: string;
}
